const currentBuild = process.env.APP_ENV

function getEnvInfo(env: string | undefined) {
  switch (env) {
    case 'development':
    case 'test':
    case 'pre':
    case 'test1':
      return {
        cms: 'https://test-cms-1.17track.net',
        user: 'https://test-user-1.17track.net',
        pay: 'https://pay.17track.net'
      }
    case 'uat':
      return {
        cms: 'https://uat-cms.17track.net',
        user: 'https://uat-user.17track.net',
        pay: 'https://pay.17track.net'
      }
    case 'production':
      return {
        cms: 'https://cms-cn.17track.net',
        user: 'https://user.17track.net',
        pay: 'https://pay.17track.net'
      }
    default:
      return {
        cms: 'https://cms-cn.17track.net',
        user: 'https://user.17track.net',
        pay: 'https://pay.17track.net'
      }
  }
}

const hostConfig = getEnvInfo(currentBuild)

export default hostConfig
